/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListConversationMessageDto } from '../../models/api-response-list-conversation-message-dto';
import { ConversationExportReq } from '../../models/conversation-export-req';

export interface ExportAllConversation$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: ConversationExportReq
}

export function exportAllConversation(http: HttpClient, rootUrl: string, params: ExportAllConversation$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListConversationMessageDto>> {
  const rb = new RequestBuilder(rootUrl, exportAllConversation.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListConversationMessageDto>;
    })
  );
}

exportAllConversation.PATH = '/v1/api/ui/conversation/export-all';
